import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLocalStorage } from "@src/appV2/lib/utils";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useEffect } from "react";

import { Button } from "../../components/Button";
import { useShiftModalsDataContext } from "../../ShiftDiscovery/useShiftModalsDataContext";
import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

export function ShiftLateCancelProtectionCard() {
  const { shiftId } = useShiftModalsDataContext();
  const { userId: workerId } = useDefinedWorker();
  const [hidden, setHidden] = useLocalStorage(`late-cancel-protection-card-hidden`, false);

  useEffect(() => {
    if (hidden) {
      return;
    }

    logEvent(APP_V2_USER_EVENTS.VIEWED_LATE_CANCEL_PROTECTION_CARD, {
      metadata: { shiftId, workerId },
    });
  }, [shiftId, workerId, hidden]);

  if (hidden) {
    return null;
  }

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="success"
      title="All shifts you book now have Late Cancel Protection"
      description="You are guaranteed 2 hours of pay if the workplace cancels this shift less than 2 hours before start."
      illustrationType="shift-protection"
      footer={
        <Button
          fullWidth
          variant="outlined"
          onClick={() => {
            setHidden(true);
          }}
        >
          Hide
        </Button>
      }
    />
  );
}
